export default __webpack_public_path__ + "static/media/Group9208.92c77237.svg";